/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetOrgGroupsSchema
 */
export interface SetOrgGroupsSchema {
    /**
     * 
     * @type {number}
     * @memberof SetOrgGroupsSchema
     */
    organizationId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SetOrgGroupsSchema
     */
    groupIds: Array<number>;
}

/**
 * Check if a given object implements the SetOrgGroupsSchema interface.
 */
export function instanceOfSetOrgGroupsSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "groupIds" in value;

    return isInstance;
}

export function SetOrgGroupsSchemaFromJSON(json: any): SetOrgGroupsSchema {
    return SetOrgGroupsSchemaFromJSONTyped(json, false);
}

export function SetOrgGroupsSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetOrgGroupsSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization_id'],
        'groupIds': json['group_ids'],
    };
}

export function SetOrgGroupsSchemaToJSON(value?: SetOrgGroupsSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
        'group_ids': value.groupIds,
    };
}

